import { Container } from "inversify";
import {
  AddressRepository,
  CartRepository,
  HomeRepository,
  ProductsRepository,
  UserRepository,
} from "./domain";
import {
  AddressRemoteDataSource,
  AddressRepositoryImpl,
  CartLocalDataSource,
  CartRepositoryImpl,
  createHttpClinet,
  HttpClient,
  ProductsRemoteDataSource,
  ProductsRepositoryImpl,
  UserRemoteDataSource,
  UserRepositoryImpl,
  UserLocalDataSource,
  HomeRemoteDataSource,
  HomeRepositoryImpl,
} from "./infrastructure";

const Services = {
  HttpClinet: Symbol.for("HttpClinet"),

  // data sources
  AddressRemoteDataSource: Symbol.for("AddressRemoteDataSource"),
  CartLocalDataSource: Symbol.for("CartLocalDataSource"),
  HomeRemoteDataSource: Symbol.for("HomeRemoteDataSource"),
  ProductsRemoteDataSource: Symbol.for("ProductsRemoteDataSource"),
  UserLocalDataSource: Symbol.for("UserLocalDataSource"),
  UserRemoteDataSource: Symbol.for("UserRemoteDataSource"),

  // repositories
  AddressRepository: Symbol.for("AddressRepository"),
  CartRepository: Symbol.for("CartRepository"),
  HomeRepository: Symbol.for("HomeRepository"),
  ProductsRepository: Symbol.for("ProductsRepository"),
  UserRepository: Symbol.for("UserRepository"),
};

const ServiceLocater = new Container();

const httpClient = createHttpClinet();
ServiceLocater.bind<HttpClient>(Services.HttpClinet).toConstantValue(
  httpClient
);

// data sources
ServiceLocater.bind<AddressRemoteDataSource>(
  Services.AddressRemoteDataSource
).toConstantValue(new AddressRemoteDataSource(httpClient));

ServiceLocater.bind<CartLocalDataSource>(
  Services.CartLocalDataSource
).toConstantValue(new CartLocalDataSource());

ServiceLocater.bind<HomeRemoteDataSource>(
  Services.HomeRemoteDataSource
).toConstantValue(new HomeRemoteDataSource(httpClient));

ServiceLocater.bind<ProductsRemoteDataSource>(
  Services.ProductsRemoteDataSource
).toConstantValue(new ProductsRemoteDataSource(httpClient));

ServiceLocater.bind<UserRemoteDataSource>(
  Services.UserRemoteDataSource
).toConstantValue(new UserRemoteDataSource(httpClient));

ServiceLocater.bind<UserLocalDataSource>(
  Services.UserLocalDataSource
).toConstantValue(new UserLocalDataSource());

// repositories
ServiceLocater.bind<AddressRepository>(
  Services.AddressRepository
).toConstantValue(
  new AddressRepositoryImpl(
    ServiceLocater.get<AddressRemoteDataSource>(
      Services.AddressRemoteDataSource
    )
  )
);

ServiceLocater.bind<CartRepository>(Services.CartRepository).toConstantValue(
  new CartRepositoryImpl(
    ServiceLocater.get<CartLocalDataSource>(Services.CartLocalDataSource)
  )
);

ServiceLocater.bind<HomeRepository>(Services.HomeRepository).toConstantValue(
  new HomeRepositoryImpl(
    ServiceLocater.get<HomeRemoteDataSource>(Services.HomeRemoteDataSource)
  )
);

ServiceLocater.bind<ProductsRepository>(
  Services.ProductsRepository
).toConstantValue(
  new ProductsRepositoryImpl(
    ServiceLocater.get<ProductsRemoteDataSource>(
      Services.ProductsRemoteDataSource
    )
  )
);

ServiceLocater.bind<UserRepository>(Services.UserRepository).toConstantValue(
  new UserRepositoryImpl(
    ServiceLocater.get<UserRemoteDataSource>(Services.UserRemoteDataSource),
    ServiceLocater.get<UserLocalDataSource>(Services.UserLocalDataSource)
  )
);

export { ServiceLocater, Services };
